import { useEffect } from "react";

type Props = {
  id: string;
  value: string;
  isDisabled?: boolean;
};

export default function useScriptFunction({
  id,
  value,
  isDisabled = false,
}: Props) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (document.getElementById(id)) return;
    if (isDisabled) return;

    const script = document.createElement("script");

    script.type = "text/javascript";
    script.innerHTML = value;
    script.id = id;

    document.head.appendChild(script);
  }, [id, value, isDisabled]);
}
